var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitediscard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(-3061 -6606)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    width: 24,
    height: 24,
    transform: "translate(3061 6606)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4786de96a91dc15ce69690fbc8a30d54",
    "data-name": "4786de96a91dc15ce69690fbc8a30d54",
    d: "M18.758,6.43A18.089,18.089,0,0,0,14.19,5,12.863,12.863,0,0,0,13.6,6.21a16.731,16.731,0,0,0-5.07,0A12.908,12.908,0,0,0,7.949,5,18.217,18.217,0,0,0,3.377,6.433,19.017,19.017,0,0,0,.094,19.209a18.3,18.3,0,0,0,5.6,2.861A13.806,13.806,0,0,0,6.9,20.1a11.826,11.826,0,0,1-1.89-.918c.159-.117.314-.237.463-.354a12.963,12.963,0,0,0,11.2,0c.152.126.307.246.463.354a11.875,11.875,0,0,1-1.893.919,13.677,13.677,0,0,0,1.2,1.966A18.214,18.214,0,0,0,22.05,19.21h0A19,19,0,0,0,18.758,6.43ZM7.394,16.636A2.14,2.14,0,0,1,5.4,14.389,2.127,2.127,0,0,1,7.39,12.132a2.118,2.118,0,0,1,2,2.257A2.137,2.137,0,0,1,7.394,16.636Zm7.357,0a2.137,2.137,0,0,1-1.993-2.248,2.127,2.127,0,0,1,1.993-2.257,2.113,2.113,0,0,1,1.991,2.257A2.136,2.136,0,0,1,14.751,16.636Z",
    transform: "translate(3061.928 6604.465)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitediscard);
export default __webpack_public_path__ + "static/media/whitediscard.2594097136307fa8dcedcdcae74f58bd.svg";
export { ForwardRef as ReactComponent };